export const TextureTypes = {
  CHALK: 'chalk-texture',
  SPONGE: 'sponge-texture',
  CLOTH: 'cloth-texture'
};
